export default function (Vue) {
    Vue.storage = {
        setStorageItem(token, data) {
            localStorage.setItem(token, data)
        },

        getStorageItem(token) {
            var token = localStorage.getItem(token)

            if(!token) {
                return null
            } else return token
        },

        destoryStorageItem() {
            localStorage.removeItem(token)
        },

    }

    Object.defineProperties(Vue.prototype, {
        $storage: {
            get() {
                return Vue.storage
            }
        }
    })
}
